import { Component, Input, OnInit } from '@angular/core';
import { ComponentView } from '../ComponentView';

@Component({
  selector: 'app-drop-down-points',
  templateUrl: './drop-down-points.component.html',
  styleUrls: ['./drop-down-points.component.scss']
})
export class DropDownPointsComponent extends ComponentView implements OnInit {


  constructor() {
    super()
   }

  ngOnInit(): void {

    if (!this.component.title) {
      this.component.title = "";
    }

    this.onCreated();
  }

}
